import { render, staticRenderFns } from "./cpt-rect-num.vue?vue&type=template&id=5a7e7a89&scoped=true"
import script from "./cpt-rect-num.vue?vue&type=script&lang=js"
export * from "./cpt-rect-num.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7e7a89",
  null
  
)

export default component.exports